'use client';

import { createContext, useContext } from 'react';
import type { SiteDomain } from '@/lib/site-domain';

// [custom-domain] Dominio personalizado de la petición, fijado por el layout raíz desde las
// cabeceras del middleware. `null` en la plataforma. Es el mismo valor en SSR y en cliente, así
// que los hrefs que dependen de él no provocan mismatch de hidratación.
const SiteDomainContext = createContext<SiteDomain | null>(null);

export function SiteDomainProvider({ value, children }: { value: SiteDomain | null; children: React.ReactNode }) {
  return <SiteDomainContext.Provider value={value}>{children}</SiteDomainContext.Provider>;
}

export function useSiteDomain(): SiteDomain | null {
  return useContext(SiteDomainContext);
}
